import { MatInputModule } from '@angular/material/input';
import { NgModule } from '@angular/core';
import { CommentsAssignmentComponent } from './comments-assignment.component';
import {
    LayoutModule,
    FuseSharedModule,
    FuseSidebarModule,
} from 'sp-office365-layout';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularFrameworkModule } from 'sp-office365-framework';
import { TableInvolvedModule } from '../../involved/table-involved/table-involved.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';

const routes = [
    {
        path: 'projects/detail/comments',
        component: CommentsAssignmentComponent,
    },
    {
        path: 'projects/detail/comments/:id',
        component: CommentsAssignmentComponent,
    },
];

@NgModule({
    declarations: [CommentsAssignmentComponent],
    imports: [
        RouterModule.forChild(routes),
        TranslateModule,
        FuseSharedModule,
        LayoutModule,
        MatIconModule,
        MatTabsModule,
        FuseSidebarModule,
        AngularFrameworkModule,
        MatCardModule,
        TableInvolvedModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
    ],
    exports: [CommentsAssignmentComponent],
})
export class CommentsAssignmentModule {}
